import { InvalidTotalExpectedBlocksByLink } from "@models/ISchema";

// CHS-2947 / CHS-2931 (backend codes VALIDATE_EXCEEDED_TOTAL_EXPECTED_BLOCKS_BY_LINK
// and VALIDATE_INSUFFICIENT_TOTAL_EXPECTED_BLOCKS_BY_LINK, PR Foris/darwined#5531).
// Kept as a named constant (rather than a literal in every switch/case) so the single
// source of truth stays here if it ever changes.
export const TOTAL_EXPECTED_BLOCKS_BY_LINK_TYPENAME: InvalidTotalExpectedBlocksByLink["__typename"] =
  "InvalidTotalExpectedBlocksByLink";

export interface TotalExpectedBlocksByLinkPayload {
  programmed: number | string;
  expected: number | string;
  difference: number | string;
}

/**
 * Both backend codes collapse into a single __typename; `allowed` is what tells them
 * apart. The backend sets it to `allowed = (code === VALIDATE_INSUFFICIENT_...)`, so
 * `true` means the link is below its expected total and `false` means it is above.
 * The flag is constant per code and does NOT vary with the user's skip ability.
 */
export const isTotalExpectedBlocksDeficit = (
  incidence: Partial<InvalidTotalExpectedBlocksByLink>,
): boolean => incidence?.allowed === true;

export const mapTotalExpectedBlocksByLinkPayload = (
  incidence: Partial<InvalidTotalExpectedBlocksByLink>,
): TotalExpectedBlocksByLinkPayload => ({
  programmed: incidence?.programmedBlocks ?? "-",
  expected: incidence?.expectedBlocks ?? "-",
  difference: incidence?.difference ?? "-",
});
